<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner bottom">
        <div class="modal">
          <div class="modal-head" v-if="title">
            <h1>{{ title }}</h1>
          </div>
          <div class="modal-con">
            <check-box-items :items="contents" :type="modalType" v-model="pickValue" />
          </div>
          <BasicButton
            modal-btn
            :single-text="callBackText"
            @click="fnFetch"
            :left-text="leftText"
            :right-text="rightText"
            @leftEvent="fnClose"
            @rightEvent="fnFetch"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onBeforeMount, onMounted, ref, toRefs, watch } from 'vue';
import { COMMENT_LIST, MODAL_TYPE } from '@/common/constants/ConstCode';
import { formatNumberToPhone } from '@/common/utils/module/FormattingSupport';
import { isEmpty } from '@/common/utils/Util';
import { showTextModal } from '@/common/utils/ModalState';
import BasicButton from '@/components/common/layouts/BasicButton.vue';
import CheckBoxItems from '@/components/common/input/CheckBoxItems.vue';
import { toastAlert } from '@/common/utils/module/ToastSupport';

const props = defineProps(['data']);
const { contents, callBackText, leftText, rightText, title } = toRefs(props.data);
const { fnCallBack, modalType, defaultValue, selectValue } = props.data;
const emits = defineEmits(['close']);
const pickValue = ref('');

onMounted(() => {
  // 교회의 경우 0번선택이 default인 경우가많음
  if (defaultValue) {
    pickValue.value = filteredContents()[0].value;
  }
  if (selectValue) {
    pickValue.value = selectValue;
  }
});
const filteredContents = () => {
  switch (modalType) {
    case MODAL_TYPE.CHURCH:
      return contents.value?.map(item => ({
        id: item.churchNo,
        label: `${item.churchName} (${item.state}, ${item.county})`,
        value: item.churchNo
      }));
    case MODAL_TYPE.FAMILY:
      return contents.value?.map(item => ({
        id: item.familyName,
        label: !isEmpty(item.birthDate)
          ? `${item.name} (${item.birthDate} / ${formatNumberToPhone(item.phone)})`
          : `${item.name}`,
        value: item.familyCode
      }));
    default:
      return contents;
  }
};
const fnFetch = () => {
  if (isEmpty(pickValue.value) && modalType === MODAL_TYPE.CHURCH) {
    toastAlert('교회 정보를 선택해 주세요.', 3000);
    return;
  }
  if (typeof pickValue.value === 'string' && selectValue) {
    // 내가 선택한 값을 기본값으로 넣어줄 경우
    pickValue.value = filteredContents().find(item => item.value === pickValue.value);
  }
  if (fnCallBack) fnCallBack(pickValue.value);

  setTimeout(() => {
    emits('close');
  }, 500);
};
const fnClose = () => {
  setTimeout(() => {
    emits('close');
  }, 500);
};
</script>

<style scoped></style>
